import { Switch } from '@mantine/core';

export type BooleanInputProps = {
  value: boolean | null | undefined;
  onChange: (value: boolean) => void;
};

export const BooleanInput = ({ value, onChange }: BooleanInputProps) => (
  <Switch
    checked={value ?? false}
    onChange={(e) => onChange(e.currentTarget.checked)}
    label={value ? 'True' : 'False'}
  />
);
